import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/store/safari.svg'
import _imports_1 from '@/assets/img/store/app-icon.png'
import _imports_2 from '@/assets/img/general/max.svg'
import _imports_3 from '@/assets/img/store/mockups/ios/installation.gif'


const _hoisted_1 = {
  key: 0,
  class: "fixed top-0 left-1/2 w-[95%] mt-5 transform -translate-x-1/2 z-10 border-2 border-orange-400 rounded-xl p-3 bg-white shadow-sm"
}
const _hoisted_2 = { class: "flex border-b border-[#E7E7E7] pb-8" }
const _hoisted_3 = { class: "flex flex-col items-start justify-between" }
const _hoisted_4 = {
  key: 0,
  class: "text-[20px] tracking-wide"
}
const _hoisted_5 = {
  key: 1,
  class: "text-[20px] tracking-wide"
}
const _hoisted_6 = { class: "mt-2 flex border-b border-[#E7E7E7] pb-2" }
const _hoisted_7 = { class: "flex flex-auto flex-col" }
const _hoisted_8 = { class: "mt-2 flex fill-[#C4C4C4] justify-center" }
const _hoisted_9 = { class: "hide-scrollbar mt-6 flex flex-nowrap overflow-x-auto whitespace-nowrap border-b border-[#E7E7E7] pb-6" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  id: "gif",
  class: "mt-6 flex justify-center flex-col items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative bg-white p-[20px] font-sans", { 'pointer-events-none': _ctx.isWebview }])
  }, [
    (_ctx.isWebview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("div", { class: "text-lg text-center" }, " Вы просматриваете страницу через встроенный браузер ", -1),
          _createElementVNode("div", { class: "flex space-x-2 items-center mt-2 flex-wrap" }, [
            _createElementVNode("p", null, "Нажмите на иконку"),
            _createElementVNode("img", {
              src: _imports_0,
              class: "w-6 h-6"
            }),
            _createElementVNode("p", null, "В правом нижнем углу")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      style: _normalizeStyle({ filter: _ctx.isWebview ? 'blur(1px)' : 'none' })
    }, [
      _createElementVNode("section", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mr-5 h-[126px] w-[126px] rounded-[20px]" }, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: "image"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            (_ctx.store?.state?.appName && _ctx.isBrand.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.appName), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, "ФорсМани Pro")),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-[12px] text-[#C4C4C4]" }, " Работа в такси и доставке ", -1))
          ]),
          _createElementVNode("button", {
            class: "rounded-full bg-[#4593FC] p-1 px-3 font-medium tracking-wide text-white",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendPromt && _ctx.sendPromt(...args)))
          }, " Инструкция ")
        ])
      ]),
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-center text-[14px] uppercase text-[#C4C4C4]" }, " 850 Отзывов ", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mt-2 text-center text-2xl font-medium text-[#A5A5A5]" }, " 4,7 ", -1)),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
              return _createElementVNode("svg", {
                key: index,
                xmlns: "http://www.w3.org/2000/svg",
                height: "18",
                class: "mr-1",
                viewBox: "0 96 960 960",
                width: "18"
              }, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("path", { d: "m196 1028 75-324L19 486l332-28 129-306 129 306 332 28-252 218 76 324-285-173-284 173Z" }, null, -1)
              ]))])
            }), 64))
          ])
        ]),
        _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"flex flex-auto flex-col\"><div class=\"text-center text-[14px] uppercase text-[#C4C4C4]\"> Возраст </div><div class=\"mt-2 text-center text-2xl font-medium text-[#A5A5A5]\"> 4+ </div></div><div class=\"flex flex-auto flex-col\"><div class=\"text-center text-[14px] uppercase text-[#C4C4C4]\"> Размер </div><div class=\"mt-2 text-center text-2xl font-medium text-[#A5A5A5]\"> 17 </div><div class=\"mt-2 text-center text-[#A5A5A5] text-[14px]\">МБ</div></div>", 2))
      ]),
      _createElementVNode("section", _hoisted_9, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
          return _createElementVNode("div", {
            key: index,
            class: "mr-3 w-[60px] min-w-[210px]"
          }, [
            _createElementVNode("img", {
              class: "rounded-[10px]",
              src: require(`@/assets/img/store/mockups/ios/slide${index}.png`),
              alt: " image"
            }, null, 8, _hoisted_10)
          ])
        }), 64))
      ]),
      _createElementVNode("section", _hoisted_11, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-center text-2xl font-medium" }, " Инструкция по установке приложения ", -1)),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "mt-2 text-xl" }, "Не получилось установить?", -1)),
        (_ctx.showMaxSupport)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMaxSupportRequest && _ctx.handleMaxSupportRequest(...args))),
              class: "mt-2 flex flex-col items-center rounded-full bg-gradient-to-r from-[#44CCFF] to-[#9932DD] px-4 py-1 text-sm font-medium text-white"
            }, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("div", { class: "flex items-center" }, [
                _createElementVNode("div", { class: "text-2xl" }, [
                  _createElementVNode("img", {
                    class: "w-5 h-5",
                    src: _imports_2
                  })
                ]),
                _createElementVNode("div", { class: "ml-2 text-base" }, "Написать в MAX")
              ], -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleTelegramSupportRequest && _ctx.handleTelegramSupportRequest(...args))),
          class: "mt-2 flex flex-col items-center rounded-full bg-[#4593FC] px-4 py-1 text-sm font-medium text-white"
        }, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("div", { class: "flex items-center" }, [
            _createElementVNode("div", { class: "text-2xl" }, [
              _createElementVNode("i", { class: "fab fa-telegram-plane" })
            ]),
            _createElementVNode("div", { class: "ml-2 text-base" }, "Написать в Telegram")
          ], -1)
        ]))]),
        _cache[14] || (_cache[14] = _createElementVNode("img", {
          class: "mt-2 max-w-[320px]",
          src: _imports_3,
          alt: "gif"
        }, null, -1))
      ]),
      _cache[15] || (_cache[15] = _createElementVNode("section", { class: "text-[#A0A0A0] text-[14px] mt-6 font-normal tracking-wide" }, " Вы могли сталкивались с ошибками при моменталках или зависанием платежей на 3-12 дней без возможности вернуть деньги обратно? В PRO версии появилась возможность моментально выбрать другой номер карты при возникновение самых распространенных ошибок переводов, а зависание платежей не происходит при использовании Системы Быстрых Платежей (отправка на карту по номеру телефона). Выводите деньги со всех крупных агрегатов заказов доставки и такси и концентрируйтесь на главном: вашей работе. Наше приложение не подведет! ", -1)),
      _cache[16] || (_cache[16] = _createElementVNode("section", { class: "mt-5 pb-3" }, [
        _createElementVNode("div", { class: "text-[#4593FC] text-[15px]" }, "Форс Технологии"),
        _createElementVNode("div", { class: "text-[13px] text-[#A0A0A0]" }, "Разработчик")
      ], -1))
    ], 4)
  ], 2))
}